export default __webpack_public_path__ + "static/saint-lambert-a0d92b1687ac24fa6d249c785152e47d.png";